import { Input } from "@jhool-io/fe-components";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { ISendLabRequestPayload } from "../../types/e-prescribe.types";

interface SendLabRequestFormProps {
    defaultEmail?: string | null;
    onSubmit(values: ISendLabRequestPayload): void;
}

export const SEND_LAB_REQUEST_FORM_ID = "send-lab-request";

const schema = z.object({
    email: z.string().trim().email("Enter a valid email address"),
});

export default function SendLabRequestForm({
    defaultEmail,
    onSubmit,
}: SendLabRequestFormProps) {
    const {
        formState: { errors },
        handleSubmit,
        register,
    } = useForm<ISendLabRequestPayload>({
        resolver: zodResolver(schema),
        defaultValues: { email: defaultEmail ?? "" },
    });

    return (
        <form
            id={SEND_LAB_REQUEST_FORM_ID}
            onSubmit={handleSubmit(onSubmit)}
            autoComplete="off"
        >
            <Input
                {...register("email")}
                label="Email"
                isRequired
                hasError={Boolean(errors.email)}
                errorText={errors.email?.message}
            />
        </form>
    );
}
